import { Component, OnInit } from '@angular/core';

@Component({
  selector: 's18-adjust-usga-score-dialog',
  templateUrl: './adjust-usga-score-dialog.component.html',
  styleUrls: ['./adjust-usga-score-dialog.component.scss']
})
export class AdjustUsgaScoreDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
